import TokenResource from "./TokenResource";

export interface KycDataModel {
	pepCheck: string;
	pepRole: string;
	vehicleUsage: string;
	paymentsOrigin: string;
	paymentsFromAbroadCheck: string;
	paymentsFromAbroadCountry: string;
	partialPaymentsOver100K: string;
}

export interface OnboardingModel {
	kyc: KycDataModel;
	consents: {
		id: string;
		consented: "true" | "false";
	}[];
	contactInfo: {
		email: string;
		mobilePhone: string;
	};
}

export default class OnboardingResource extends TokenResource implements OnboardingModel {
	kyc = {} as KycDataModel;
	consents = [] as { id: string, consented: "true" | "false" }[];
	contactInfo = {
		email: "",
		mobilePhone: ""
	};

	pk() {
		return "onboarding_singleton";
	}

	static urlRoot = "/api/onboarding";
}

export interface OnboardingStatusResult {
	errorMessage: string;
	success: boolean;
}
